import "../css/styles.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, {Component} from "react";
import { Link } from 'react-router-dom';
import TelevisionBreakpoint from "../components/responsive_utilities/television_breakpoint";
import DesktopBreakpoint from "../components/responsive_utilities/desktop_breakpoint";
import TabletBreakpoint from "../components/responsive_utilities/tablet_breakpoint";
import PhoneBreakpoint from "../components/responsive_utilities/phone_breakpoint";
import { LogsPhone } from "../components/CompsPhone/LogsPhone";


var firebase = require('firebase/app');
require('firebase/database');

class AnglerDetails extends Component {
  
  constructor() {
    super();
    this.state = {
      tournamentHref: 'pelagicquepostest',
      tourLogo: '',
      firstName: '',
      lastName: '',
      logs: {},
      species: {},
      anglers: {},
      boats: {}
    };
    this.tourRef = firebase.database().ref('tournaments/-LUov1SAtOWRIEdgf__s');
  }
  
  componentWillMount() {
  this.tourRef.child('fishLogs').orderByChild("anglerId").equalTo(this.props.match.params.anglerId).once('value', this.handleFishLogsUpdate);
    this.tourRef.once('value', this.handleTournament);
  }
  
  handleFishLogsUpdate = (snapshot) => {
    var logs = []
    snapshot.forEach((snap) => {
      logs.push(snap.val())
    })
    this.setState({
      logs
    })
  }
  
  goBack = () => {
      window.history.back();
  }
  
  handleTournament = (snapshot) => {
    var tournamentHref = snapshot.val().href;
    var tourLogo = snapshot.val().logoUri;
    var anglers = snapshot.val().anglers;
    var anglersArray = Object.entries(anglers);
    var species = snapshot.val().species;
    var boats = snapshot.val().boats;
    anglersArray.forEach((angler) => {
        if(angler[0] === this.props.match.params.anglerId) {
            this.setState({
              firstName: angler[1].firstName,
              lastName: angler[1].lastName
            })
        }
    })
    this.setState({
      species,
        boats,
        anglers,
        tournamentHref,
        tourLogo
    })
    
  }
  
  render () {
    return (
      <div className="main-container">
        <TelevisionBreakpoint>
          <div style={{zIndex: -1, display: this.state.loadingVis}}>
            <h4>{this.state.firstName} {this.state.lastName}</h4>
          </div>
        </TelevisionBreakpoint>
        <DesktopBreakpoint>
          <div style={{display: this.state.loadingVis}}>
            <div className="anglerDetailTitle">{this.state.firstName} {this.state.lastName}</div>
            {!this.state.species ? null : <LogsPhone logs={this.state.logs} speciesRaw={this.state.species} boatsRaw={this.state.boats} anglersRaw={this.state.anglers}/> }
          </div>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <div style={{display: this.state.loadingVis}}>
            <div className="anglerDetailTitle">{this.state.firstName} {this.state.lastName}</div>
            {!this.state.species ? null : <LogsPhone logs={this.state.logs} speciesRaw={this.state.species} boatsRaw={this.state.boats} anglersRaw={this.state.anglers}/> }
          </div>
        </TabletBreakpoint>
        <PhoneBreakpoint>
          <div style={{display: this.state.loadingVis}}>
            <div className="detailsHeader" style={{
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50% 50%',
                backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/speciesFlags%2FbaitBall.jpg?alt=media&token=00f17f39-0f5a-4c35-aba0-1ab99dd0d41c)'}}>
                <div className='tourLogoHeader' 
                  style={{
                    backgroundImage: 'url(' +  this.state.tourLogo  + ')'
                  }} />
            </div>
            <Link to={"/pelagicquepostest"}><div className="backButton">Back</div></Link>
            <div className="anglerDetailTitle">{this.state.firstName} {this.state.lastName}</div>
            {!this.state.species ? null : <LogsPhone logs={this.state.logs} speciesRaw={this.state.species} boatsRaw={this.state.boats} anglersRaw={this.state.anglers}/> }
          </div>
        </PhoneBreakpoint>
      </div> 
    );
  }
}

export default AnglerDetails;


// WEBPACK FOOTER //
// ./src/pages/AnglerDetails.js